import { ButtonType } from '../../modal/button.handler';
import { InitButton } from '../../modal/modal.button';
import { ModalHandler } from '../../modal/modal.handler';

export function internalErrorHandler(): ModalHandler {
   const handler: ModalHandler = new ModalHandler();
   handler.title = 'Error happened.';
   handler.text = 'Please try again later, or try refreshing the page.';
   [handler.buttons] = InitButton({ type: ButtonType.Ok, prefix: 'internal-error' }, 1);
   handler.keyboard = false;
   handler.ignoreBackdropClick = true;
   handler.closeButton = false;
   return handler;
}
